import { IBIReport } from "../../../Interfaces/Geral/RelatoriosBI/RelatoriosBIInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export type TypeModulosBI =
    | "BICobranca"
    | "BIAtendimento"
    | "BIAssistencia"
    | "BIRepasse"
    | "BIEntregaChaves"
    | "BIPerfilClientes"
    | "BIWhatsApp"
    | "BIAutomacao";

export async function GetPowerBIReportService(dsModuloBi: TypeModulosBI) {
    return Service(
        Axios.get<IBIReport>(
            `/home/powerbireport/getpowerbireport?dsModuloBi=${dsModuloBi}`
        )
    );
}
